module.exports = __webpack_public_path__ + "img/qrcode-1448.4e9725ff.png";